module.exports = __webpack_public_path__ + "static/img/zw1.95bf935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/zw1.png
// module id = gH38
// module chunks = 13